<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Continuous Comprehensive Evaluation Chart </strong>
                </v-toolbar-title>
            </v-toolbar>
            <br />
            <v-row dense justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        rounded
                        outlined
                        dense
                        v-model="academicYear"
                        :items="academic_year_list"
                        item-text="ay"
                        label="Academic Year"
                        return-object
                        @change="onLoad()"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @click="show = false"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        rounded
                        outlined
                        dense
                        v-model="stud"
                        :items="stud_list"
                        item-text="lname"
                        item-value="lid"
                        label="Select Student"
                    ></v-autocomplete>
                </v-col>
                <v-btn class="mt-6 button" v-if="stud" @click="getReport()" :loading="fetch_loader">Fetch</v-btn>
            </v-row>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
        <v-card class="box" flat v-if="individual_sheet_list != ''">
            <v-row>
                <v-col sm="2">
                    <v-btn
                        class="no-display"
                        rounded
                        color="success"
                        outlined
                        @click="fnExcelReport('my-table-id', 'individual_sheet')"
                        :loading="loader"
                        ><v-icon color="success">mdi-export</v-icon>Export</v-btn
                    >
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-btn class="no-display" tile outlined color="warning" @click="print()">
                        <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <div id="my-table-id">
                <v-col cols="12" sm="12" md="12"> </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td :colspan="totalColumns">
                                    <center>{{ org_basic_data.trust_name }}</center>
                                </td>
                            </tr>

                            <tr>
                                <td :colspan="totalColumns">
                                    <center>{{ org_basic_data.school_name }}</center>
                                </td>
                            </tr>

                            <tr>
                                <td :colspan="totalColumns">
                                    <center>Year {{ academicYear }}</center>
                                </td>
                            </tr>

                            <tr>
                                <td :colspan="totalColumns">
                                    <center>Continuous Comprehensive Evaluation Chart</center>
                                </td>
                            </tr>

                            <tr>
                                <td :colspan="parseInt(totalColumns / 2)">
                                    <center>
                                        <strong>Student Name :</strong>
                                        {{ name }}
                                    </center>
                                </td>

                                <td :colspan="parseInt(totalColumns / 2)">
                                    <center>
                                        <strong>Std :</strong>
                                        {{ standard }}
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td :colspan="parseInt(totalColumns / 3)">
                                    <center>
                                        <strong>Term :</strong>
                                        {{ semester }}
                                    </center>
                                </td>

                                <td :colspan="parseInt(totalColumns / 3)">
                                    <center>
                                        <strong>Div :</strong>
                                        {{ division }}
                                    </center>
                                </td>

                                <td :colspan="parseInt(totalColumns / 3)">
                                    <center>
                                        <strong>Roll No :</strong>
                                        {{ roll_no }}
                                    </center>
                                </td>
                            </tr>

                            <!-- HEADER ROW -->

                            <tr>
                                <td>
                                    <center>Sr.No</center>
                                </td>

                                <td>
                                    <center>Subject</center>
                                </td>

                                <td>
                                    <center>Type</center>
                                </td>

                                <template v-for="(rubrics, evalType) in evaluationTypeRubricsMap">
                                    <td :colspan="rubrics.length" :key="evalType + '_head'">
                                        <center>
                                            {{ evalType }}
                                        </center>
                                    </td>

                                    <td :key="evalType + '_total_head'">
                                        <center>Total</center>
                                    </td>
                                </template>

                                <td>
                                    <center>Overall</center>
                                </td>
                            </tr>

                            <!-- RUBRICS ROW -->

                            <tr>
                                <td></td>

                                <td></td>

                                <td></td>

                                <template v-for="(rubrics, evalType) in evaluationTypeRubricsMap">
                                    <td v-for="rubric in rubrics" :key="evalType + rubric">
                                        <center>{{ rubric }}</center>
                                    </td>

                                    <td :key="evalType + '_blank'"></td>
                                </template>

                                <td></td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(c, index) in individual_sheet_list" :key="index">
                                <!-- SR NO -->
                                <td>
                                    <center>{{ c.srno }}</center>
                                </td>

                                <!-- SUBJECT -->
                                <td>
                                    <center>{{ c.c_name }}</center>
                                </td>

                                <!-- TYPE -->
                                <td>
                                    <center>{{ c.marks }}</center>
                                </td>

                                <!-- DYNAMIC EVALUATION TYPES -->
                                <template v-for="(rubrics, evalType) in evaluationTypeRubricsMap">
                                    <!-- RUBRICS -->
                                    <td v-for="(rubric, rIndex) in rubrics" :key="evalType + '_' + rIndex">
                                        <center>
                                            <!-- MARKS OUT OF -->
                                            <span v-if="c.evaluationWiseMarksOutOff">
                                                {{ ( c.evaluationWiseMarksOutOff[evalType] &&
                                                c.evaluationWiseMarksOutOff[evalType][rIndex] != null &&
                                                c.evaluationWiseMarksOutOff[evalType][rIndex] !== '' ) ?
                                                c.evaluationWiseMarksOutOff[evalType][rIndex] : '-' }}
                                            </span>

                                            <!-- MARKS OBTAINED -->
                                            <span v-else>
                                                {{ ( c.evaluationWiseObtained && c.evaluationWiseObtained[evalType] &&
                                                c.evaluationWiseObtained[evalType][rIndex] != null &&
                                                c.evaluationWiseObtained[evalType][rIndex] !== '' ) ?
                                                c.evaluationWiseObtained[evalType][rIndex] : '-' }}
                                            </span>
                                        </center>
                                    </td>

                                    <!-- TOTAL -->
                                    <td :key="evalType + '_total'">
                                        <center>
                                            <!-- OUT OFF TOTAL -->
                                            <span v-if="c.evaluationWiseTotalOutOff">
                                                {{ ( c.evaluationWiseTotalOutOff[evalType] &&
                                                c.evaluationWiseTotalOutOff[evalType][0] != null ) ?
                                                c.evaluationWiseTotalOutOff[evalType][0] : '-' }}
                                            </span>

                                            <!-- OBTAINED TOTAL -->
                                            <span v-else>
                                                {{ ( c.evaluationWiseTotal && c.evaluationWiseTotal[evalType] &&
                                                c.evaluationWiseTotal[evalType][0] != null ) ?
                                                c.evaluationWiseTotal[evalType][0] : '-' }}
                                            </span>
                                        </center>
                                    </td>
                                </template>

                                <!-- OVERALL -->
                                <td>
                                    <center>{{ c.overall_marks_total != null ? c.overall_marks_total : '-' }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            search: "",
            academic_year_list: [],
            academicYear: null,
            stud_list: [],
            stud: null,
            fetch_loader: false,
            semester_list: [],
            sem: null,
            individual_sheet_list: [],
            standard: null,
            roll_no: null,
            division: null,
            name: null,
            semester: null,
            org_basic_data: [],
            academicYear: null,

            evaluationTypeRubricsMap: {},
            evaluationTypeAssessmentMap: {},
        }),

        computed: {
            evaluationTypes() {
                return Object.keys(this.evaluationTypeRubricsMap || {});
            },

            totalColumns() {
                let total = 8;

                this.evaluationTypes.forEach((type) => {
                    total += this.evaluationTypeRubricsMap[type].length || 0;

                    total += 1;
                });

                return total;
            },
        },

        watch: {},
        mounted() {
            this.getAy();
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //   type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            getReport() {
                let ay;
                if (this.academicYear.ay_id) {
                    ay = this.academicYear.ay_id;
                } else if (this.academicYear.id) {
                    ay = this.academicYear.id;
                }
                const formData = {
                    ay: ay,
                    stud: this.stud,
                    sem: this.sem,
                };
                this.fetch_loader = true;
                axios
                    .post("/ZealExamination/getIndividualEvaluationChart", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.individual_sheet_list = res.data.individual_sheet_list;
                            this.standard = res.data.standard;
                            this.roll_no = res.data.roll_no;
                            this.division = res.data.division;
                            this.name = res.data.name;
                            this.semester = res.data.semester;
                            this.org_basic_data = res.data.org_basic_data;
                            this.academicYear = res.data.academicYear;
                            this.fetch_loader = false;

                            this.evaluationTypeRubricsMap = res.data.evaluationTypeRubricsMap;
                            this.evaluationTypeAssessmentMap = res.data.evaluationTypeAssessmentMap;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            getAy() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.academic_year_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            onLoad() {
                let ay;
                if (this.academicYear.ay_id) {
                    ay = this.academicYear.ay_id;
                } else if (this.academicYear.id) {
                    ay = this.academicYear.id;
                }
                const formData = {
                    ay: ay,
                };
                this.overlay = true;
                axios
                    .post("/ZealExamination/getStudIndividualEvaluationChart", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.stud_list = res.data.stud_data;
                            this.overlay = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
        },
    };
</script>
<style scoped>
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(
            to right,
            #2c5364,
            #203a43,
            #0f2027
        ) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(
            to right,
            #2c5364,
            #203a43,
            #0f2027
        ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }

    ol.s {
        list-style-type: inherit;
    }

    /* print css */
    @media print {
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
            margin-top: none !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
            margin-top: none !important;
        }
        v-card {
            border: none !important;
            margin-top: none !important;
        }
        * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
        @page {
            size: A4;
            margin-top: none !important;
            padding-top: none !important;
            /* size: 15.5in 15.5in; */
            size: 13.5in 16.5in;
        }

        .box {
            /* background-color: white !important; */
            /* margin: 0px !important; */
            /* margin-top: -20px !important; */
            padding: 0px;
            border: none !important;
        }
    }
    /* print css end */
</style>
